import React, { useEffect } from "react";
import SelectValue from "../Selector/SelectValue";
import { useDispatch } from "react-redux";
import { getReportSurveyOverView } from "../../../services/slice/SurveySlice";
import { useSelector } from "react-redux";
import { surveySelector } from "../../../services/selector/index.";
import PiceChart from "../Chart/PiceChart";

const TabDetailDashboardSurvey = ({ config }) => {
  const dispatch = useDispatch();
  const surveyState = useSelector(surveySelector);
  const { bodyReportSurveyOverView, dataOverview } = surveyState;
  useEffect(() => {
    if (config?.timeStart || config?.timeEnd) {
      dispatch(
        getReportSurveyOverView({
          id: Number(config?.id),
          typeSurvey: Number(config?.typeSurvey),
          typeTime: Number(config?.typeTime),
          timeStart: config?.timeStart,
          timeEnd: config?.timeEnd,
        })
      );
    }
  }, [config.id, config.typeSurvey, config, dispatch]);
  const listColor = [
    "#8BC348",
    "#FF6407",
    "#69CEF6",
    "rgba(254, 122, 5, 1)",
    "rgba(249, 50, 87, 1)",
    "rgba(255, 184, 34, 1)",
    "rgba(254, 12, 5, 1)",
    "rgba(209, 20, 77, 1)",
    "rgba(0, 131, 15, 1)",
    "rgba(0, 175, 152, 1)",
    "rgba(255, 203, 119, 1)",
    "rgba(40, 167, 216, 1)",
  ];
  return (
    <div className="wrapperTabDetailDashboard">
      {dataOverview.map((item, index) => {
        const listAnswer = [];
        const dataChart = [];
        item.questionOverViewList.map((element) => {
          listAnswer.push(element.answer);
          return dataChart.push((element.totalAnswer / item.total) * 100);
        });
        return (
          <div className="itemQuestion mb-[26px]">
            <div className="nameQuestion ">
              Câu {index + 1}: {item.questionName}
            </div>
            <div className="contentQuestion">
              <div className="totalAnswer">
                Tổng số câu trả lời: {item.total}
              </div>
              <div className="chart w-[70%] flex">
                <div className="pieChart">
                  <PiceChart
                    height={200}
                    width={200}
                    listColor={listColor}
                    dataChart={dataChart}
                  />
                </div>
                <div className="labelChart flex flex-col h-[200px] justify-evenly w-[35%] ">
                  {listAnswer.map((answer, index) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "2rem",
                        }}
                      >
                        <div
                          className={`dotChart inline-block mr-4 w-[25px] h-[25px] rounded-full `}
                          style={{
                            background: `${listColor[index]}`,
                            cursor: "pointer",
                          }}
                        ></div>{" "}
                        <span
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          {" "}
                          {answer}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TabDetailDashboardSurvey;
